export default {
  DIRECTORIES: (state) => state.directories,
  AUTOCOMPLETE_DIRECTORIES: (state) =>
    state.directories.data.map((v) => ({ id: v.id, title: v.dish.title })),
};
